<template>
<!-- :class="{active:activeIndex==index}" -->
    <div class='dataapi_wrap'>
        <GobackBar :stokeType="stokeType"></GobackBar>
        <el-container>
            <el-aside >
                <div class="aside_top">{{stokeType}}</div>
                <!-- 左侧导航栏 -->
                <el-menu :default-openeds="menuList.map(item=>item.id+'')" class='el-menu-vertical-demo'
                         :unique-opened='true' :collapse-transition='true'>
                    <div v-for='item in menuList' :key='item.id'>
                        <el-submenu v-if='item.subMenuList.length' :index='String(item.id)'
                                    :class='{active:activeIndex == item.id}' @click.native='changeActive(item.id,item)'>
                            <template slot='title'>
                                <span></span>
                                <span>{{ item.title }}</span>
                            </template>
                            <el-menu-item v-for='n in item.subMenuList' :key='n.id' :index='String(n.id)'
                                          @click='changeItemActive(n)'>{{ n.title }}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index='String(item.id)' @click.native='changeActive(item.id,item)'>
                            {{ item.title }}
                        </el-menu-item>
                    </div>
                </el-menu>
            </el-aside>
            <!-- 右侧主体数据 -->
            <el-main><slot name="stock_detail"></slot></el-main>
        </el-container>
    </div>
</template>

<script>
export default {
    data () {
        return {
            activeIndex:'',
            stokeType:''
        }
    },
    props:{
        menuList:{
            type:Array,
            data() {
                return {}
            },
        },
    },
created(){
  this.changeContent()
},
methods:{
    changeActive(index,item){
        this.activeIndex = index
        this.$emit('changeActive',index,item)
    },
    changeItemActive(item){
        this.$emit('changeItemActive',item.id,item)
    },
    changeContent(){
        switch(this.$route.path){
            case '/dataSourceStockData':
                this.stokeType = '股票数据'
            break;
            case '/dataSourceFuturesData':
                this.stokeType = '期货数据'
              break;
            case '/optionData':
                this.stokeType = '期权数据'
            break;
            case '/foreignData':
                this.stokeType = '外汇数据'
            break;
            case '/energyData':
                this.stokeType = '能源数据'
            break;
            case '/otherData':
                this.stokeType = '另类数据';
                break;
            case '/accountingData':
                this.stokeType = '财会数据';
                break;
        }
    }
}
}
</script>

<style lang='scss' scoped>

.delete_btn{
  margin-left: calc(100% - 60px);
}
.select_tips{
  margin: 30px;
  opacity: 0.4;
}
.loader {
  color: #002D72;
  font-size: 6px;
  margin: -20px 0 0 350px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
/deep/ .el-page-header__left {
    color: #271B63;
    font-weight: bold;
    .el-icon-back {
        font-size: 22px;
    }
    .el-page-header__title {
        font-size: 22px;
    }
    .el-page-header__title::after {
        font-size: 22px;
        font-weight: 600;
    }
}
/deep/.el-radio__label {
    font-size: 20px;
    color: #271B63;
}
 /deep/ .el-submenu__title{
    font-size: 20px !important;
    color: #271B63;
  }
.active{
  /deep/ .el-submenu__title{
    font-size: 20px !important;
    font-weight: bold;
    color: #002D72;
    border-left: 5px solid #002D72;
  }
}
/deep/ .el-menu{
  width: 100%;
}
/deep/ .el-menu-item{
  font-size: 18px !important;
}
.but_btn{
  width: 35%;
  // background: #888888;
}
.isactive{
  background:#002D72;
}
.notactive{
  background:#CACACA;
}
.top_tips{
    margin-bottom: 30px;
    height: 33px;
    line-height: 33px;
    font-size: 26px;
    color: #271B63;
    font-weight: bold;
    border-left: 8px solid #002D72;
  }
.aside_top{
  color: #271B63;
  font-size: 24px;
  font-weight: bold;
  margin-left: 22px;
  padding: 18px 0;
}
.left3{
  margin-left: 3%;
}
.donload_btn{
  margin:30px 0 0 70px;
  width: 160px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  text-align: center;
  border-radius: 5px;
}
.donload_btn:hover{
  opacity: 0.8;
  cursor: pointer;
}

.dataapi_wrap{
    width: 100%;
    background: #F7F7F7;
    .header{
        width: 100%;
        height: 70px;
        background: url(../../assets/img/header_bg.png) 0 0/100% 100% no-repeat;
    }
    .page_header{
      width: 35%;
      margin-top: 100px;
      font-size: 20px;
    }
    .gonext:hover{
      cursor: pointer;
      opacity: 0.6;
    }
    .el-container{
      width: 100%;
      margin-top: 10px;
      .el-aside{
        width: 15% !important;
        min-height: 40vh;
        min-height:calc(100vh - 200px);
        margin-left: 10px;
        box-shadow: 0px 3px 6px #888888;
        border-radius: 10px 10px 0px 0px;
        background: #fff;
        margin-top: 20px;
      }
      .el-main{
        width: 70%;
        margin-left: 30px;
        padding-bottom: 100px;
        .main_top{
          width: 91%;
          padding: 30px 80px;
          border-radius: 10px 10px 0px 0px;
          margin-left: -1%;
          background: #fff;
          .top_left{
            width: 50%;
            .content{
              font-size: 20px;
              color: #271B63;
            }
          }
          .top_img{
            width: 650px;
            height: 298px;
            background: url(../../assets/img/ariximg.png) 0 0/100% 100% no-repeat;
          }
        }
        .main_mid{
          width: 91%;
          padding: 30px 80px 80px 80px ;
          border-radius: 10px 10px 0px 0px;
          margin-left: -1%;
          margin-top: 30px;
          background: #fff;

            .serch_list{
            min-height: 140px;
            border: 1px solid #002D72;
            margin-top: 30px;
            padding: 0 0 30px;
            display: flex;
            flex-wrap: wrap;
            .list_item{
              width: 15%;
              height: 50px;
              font-size: 18px;
              color: #271B63;
              margin:30px 2.5% 0 2.5%;
            }
            .list_item{
              opacity: 0.8;
              cursor: pointer;
            }
          }
          .is_choose{
            font-size: 20px;
            font-weight: bold;
            color:#271B63 ;
            width: 100px;
          }
          .serch_box{
            /deep/ .el-input__inner{
              width: 300px;
              margin-right: 5px;
            }
          }
          .time_select{
            width: 400px;
            /deep/ .el-icon-date{
              font-size: 20px;
            }
          }
        }
      }
    }
}
</style>
